<template>
  <div class="featured-block-wrapper" v-if="featuredElements.length">
    <div
      class="featured-slide"
      v-for="(element, index) in featuredElements"
      :key="element.content?.id || index"
      :data-index="index"
      :style="getSlideStyles(element)"
    >
      <div class="featured-content-container site-margin">
        <div class="featured-text-content">
          <h5 class="featured-text-content-header">{{ element.content?.properties?.heading || 'Untitled' }}</h5>
          <div class="featured-text-inner-scroll">
            <p>{{ element.content?.properties?.body || 'No content provided.' }}</p>
          </div>
        </div>
        <div class="featured-rive-canvas-content">
          <canvas :id="`canvas-${index}`" class="featured-rive-canvas featured-element"></canvas>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="featured-fallback-message">
    <p></p>
  </div>
</template>

<script>
import axios from "axios";
import * as rive from "@rive-app/canvas";

export default {
  name: "FeaturedBlock",
  data() {
    return {
      featuredElements: [],
    };
  },
  mounted() {
    const routePath = window?.location?.pathname || "/";

    axios
      .get(`/umbraco/delivery/api/v1/content/item/${routePath}`)
      .then((response) => {
        const components = response?.data?.properties?.components?.items || [];

        const featuredBlock = components.find(
          (item) => item?.content?.contentType === "featuredBlock"
        );

        if (!featuredBlock) {
          console.warn("No featuredBlock found.");
          return;
        }

        this.featuredElements =
          featuredBlock?.content?.properties?.featuredItem?.items || [];

        this.$nextTick(() => {
          this.initRiveAnimations();
          this.initScrollListener();
        });
      })
      .catch((error) => {
        console.error("Failed to load featured elements:", error);
      });
  },
  methods: {
    initRiveAnimations() {
      this.featuredElements.forEach((item, index) => {
        const canvasId = `canvas-${index}`;
        const canvas = document.getElementById(canvasId);
        const riveUrl = item?.content?.properties?.image?.[0]?.url;

        if (!canvas || !riveUrl) {
          console.warn(`Missing canvas or Rive URL for index ${index}`);
          return;
        }

        const riveInstance = new rive.Rive({
          src: riveUrl,
          canvas: canvas,
          autoplay: true,

          onLoad: () => {
            riveInstance.resizeDrawingSurfaceToCanvas();
          },

          onPlay: (event) => {
            const name = event.data;
            if (name === "Entry" || name === "Exit") {
              riveInstance.play(name);
            }
          },

          onStop: (event) => {
            const name = event.data;
            riveInstance.play(name);
          }

        });
      });
    },

    initScrollListener(){
      const scrollContainer = document.querySelector('.featured-block-wrapper');
      if(!scrollContainer) return;
      scrollContainer.addEventListener('scroll', () => {
        this.handleScroll();
      })
    },

    getSlideStyles(element) {
      const bgHex = element?.content?.properties?.backgroundColour?.color || "000000";
      const fontHex = element?.content?.properties?.fontColour?.color || "ffffff";

      if (bgHex === "0b1c36") {
        return { 
          background: "linear-gradient(to right, #104B81, #0B1C36)", 
          color: `#${fontHex}`,
        };
      } else{
        return {
          background: `#${bgHex}`,
          color: `#${fontHex}`,
        };
      }
    },

    handleScroll() {
      // const slides = this.$el.querySelectorAll('.featured-slide');
      // const viewportHeight = window.innerHeight;

      // slides.forEach((slide) => {
      //   const textInner = slide.querySelector('.text-inner-scroll');
      //   const slideRect = slide.getBoundingClientRect();
      //   if (!textInner) return;

      //   const slideTop = slideRect.top;
      //   const slideHeight = slideRect.height;

      //   // Calculate slide's center position relative to viewport center
      //   const slideCenter = slideTop + slideHeight / 2;
      //   const viewportCenter = viewportHeight / 2;

      //   const distanceFromCenter = slideCenter - viewportCenter;
      //   // console.log(distanceFromCenter)

      //   // Only start transforming when slide starts to move above center
      //   if (distanceFromCenter >= 0) {
      //     textInner.style.transform = `translateY(0px)`;
      //   } else {
      //     // The further above center it gets, the more it translates
      //     const maxTranslate = 100;
      //     const progress = Math.min(Math.abs(distanceFromCenter) / viewportHeight, 1);
      //     const translateY = progress * maxTranslate;

      //     textInner.style.transform = `translateY(${translateY}px)`;
      //   }
      // });
    },
  }
};
</script>
